module.exports = __webpack_public_path__ + "media/metronic/_theme/media/misc/bg-2-a8b7ee1a2cef20c1ed0a939d05a33f90.jpg";